// Modelo normalizado del análisis.
//
// Toma la salida de un parser (hoy parser-cabrillo.js; mañana, por ejemplo,
// parser-adif.js) y le agrega los agregados estáticos que el Analizador
// original calculaba dentro de load() justo después de parse(): el cubo
// banda×bloque×continente (cnt/mx, para el chart principal) y el conteo
// banda×hora (hr, para el ritmo de contactos y los KPI). Esos cálculos NO
// dependen del cursor de tiempo ni de filtros — se calculan una sola vez
// por modelo cargado, por eso viven acá y no en motor.js.
//
// Deliberadamente NO se transforma la forma de D/PL/CN/bands/etc.: es la
// misma estructura que ya devolvía parse() en el original. El "modelo
// normalizado" es, en este punto, la salida del parser + estos dos
// agregados — sin abstracción adicional, para minimizar riesgo de
// introducir diferencias con el original.
//
// Basado en el Analizador Cabrillo original de XQ2OP (load(), líneas
// 81-83 de public/cabrillo/src/plantilla.html). Ver src/cabrillo/CREDITOS.md.

import { CONT } from './constantes.js';

/**
 * @param {object} resultadoParser - salida de parser-cabrillo.parse() (sin error)
 * @returns {object} modelo con hdr,D,PL,CN,bands,t0,NB,home,bad,cc + cnt,mx,hr
 */
export function construirModelo(resultadoParser) {
    const { D, bands, NB } = resultadoParser;

    // cnt[banda][bloqueDe10min][continente] = cantidad de QSO
    const cnt = bands.map(() => Array.from({ length: NB }, () => CONT.map(() => 0)));
    D.forEach((r) => cnt[r[1]][r[0]][r[2]]++);

    // mx = máximo acumulado banda/bloque (para normalizar la altura del chart)
    let mx = 1;
    cnt.forEach((a) =>
        a.forEach((v) => {
            const s = v.reduce((p, c) => p + c, 0);
            if (s > mx) mx = s;
        })
    );

    // hr[banda][horaDeReloj] = cantidad de QSO (bloques de 10 min agrupados de a 6 = 1 hora)
    const hr = bands.map(() => Array(Math.ceil(NB / 6)).fill(0));
    D.forEach((r) => hr[r[1]][Math.floor(r[0] / 6)]++);

    return { ...resultadoParser, cnt, mx, hr };
}
